import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Context } from '../..'
import LatestArticles from './LatestArticles'
import placeholderMini from '../../images/placeholder-mini.png'

import '../../scss/complex/ratings.scss'
import '../../scss/complex/centerDetail.scss'

const getInstagram = (item) => {
    if (item?.instagram) {
        return item.instagram.replace(/^@/, '').replace(/^https?:\/\/(www\.)?instagram\.com\//, '').replace(/\/.*$/, '');
    }

    const match = item?.description?.match(/instagram\.com\/([A-Za-z0-9._]+)/);

    return match ? match[1] : null;
};

const parseCoordinates = (value) => {
    if (!value) {
        return null;
    }

    let lat;
    let lon;

    if (Array.isArray(value)) {
        [lat, lon] = value;
    } else if (typeof value === 'object') {
        lat = value.lat ?? value.latitude;
        lon = value.lon ?? value.lng ?? value.longitude;
    } else {
        let text = String(value).replace(/["'«»\s]+/g, ' ').trim();

        if (!text.includes('.') && /^-?\d+,\d+[ ;]+-?\d+,\d+$/.test(text)) {
            text = text.replace(/(\d),(\d)/g, '$1.$2');
        }

        [lat, lon] = (text.match(/-?\d+(?:\.\d+)?/g) || []);
    }

    lat = parseFloat(lat);
    lon = parseFloat(lon);

    if (!Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) {
        return null;
    }

    return { lat, lon };
};

const CenterDetailContainer = observer(({item}) => {
    const {app} = useContext(Context);

    const translate = (key, fallback) => {
        return app.localizationsItems?.[key] || fallback;
    };

    const gallery = (item?.gallery?.length
        ? item.gallery.map((img) => typeof img === 'string' ? img : img?.url || img?.image)
        : [item?.image || item?.detail_image || item?.preview_image]
    ).filter(Boolean).slice(0, 3);

    const phone = item?.phone;
    const instagram = getInstagram(item);

    const address = [item?.region, item?.address].filter(Boolean).join(', ');

    const coords = parseCoordinates(item?.coordinates);
    const hasCoords = Boolean(coords);
    const lat = coords?.lat;
    const lon = coords?.lon;

    const mapSrc = `https://yandex.ru/map-widget/v1/?ll=${lon},${lat}&z=16&pt=${lon},${lat},pm2rdm`;

  return (
    <div className="ratings-container center-detail">
        <div className="ratings-pattern"/>

        <div className="container">
            <div className="article-container-grid ratings-grid">
                <div className="ratings-content">
                    <h2 className="ratings-title">{item?.title}</h2>

                    {gallery.length > 0 &&
                        <div
                            className="center-detail__gallery"
                            style={{gridTemplateColumns: `repeat(${gallery.length}, minmax(0, 1fr))`}}
                        >
                            {gallery.map((src, index) =>
                                <img
                                    key={index}
                                    src={src}
                                    alt={item?.title}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = placeholderMini
                                    }}
                                />
                            )}
                        </div>
                    }

                    <div
                        className="center-detail__description"
                        dangerouslySetInnerHTML={{__html: item?.description}}
                    />

                    <div className={`center-detail__bottom ${hasCoords ? '' : 'center-detail__bottom--no-map'}`}>
                        <div className="center-detail__contacts">
                            <h3 className="center-detail__contacts-title">
                                {translate('contacts', 'Контакты')}
                            </h3>

                            <div className="center-detail__address">
                                {address && <div>{address}</div>}
                            </div>

                            {(phone || instagram) &&
                            <ul className="center-detail__list">
                                {phone &&
                                <li>
                                    <span className="center-detail__label center-detail__label--phone">
                                        <i className="icon-phone"></i>
                                        {translate('phone_number', 'Номер телефона')}
                                    </span>
                                    <a
                                        href={`tel:${phone.replace(/[^\d+]/g, '')}`}
                                        className="center-detail__phone"
                                    >
                                        {phone}
                                    </a>
                                </li>
                                }
                                {instagram &&
                                <li>
                                    <span className="center-detail__label center-detail__label--social">
                                        <i className="icon-instagram"></i>
                                        {translate('instagram', 'Инстаграм')}
                                    </span>
                                    <a
                                        href={`https://www.instagram.com/${instagram}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="center-detail__social"
                                    >
                                        @{instagram}
                                    </a>
                                </li>
                                }
                            </ul>
                            }
                        </div>

                        {hasCoords &&
                            <div className="center-detail__map">
                                <iframe
                                    src={mapSrc}
                                    title={item?.title}
                                    frameBorder="0"
                                    allowFullScreen
                                    loading="lazy"
                                />
                            </div>
                        }
                    </div>
                </div>

                <div>
                    <LatestArticles gray={true}/>
                </div>
            </div>
        </div>
    </div>
  )
})

export default CenterDetailContainer
